import { createSelector } from 'reselect';
import studentSelector from './student';

export const hasStudentSelector = createSelector(studentSelector, (student) => !!student);
